<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="sc-dhKdcB jJoage">
    <path
      d="m20.104 17.933-4.9-4.9A6.02 6.02 0 1 0 4.838 6.91a6.02 6.02 0 0 0 8.245 8.245l4.9 4.9 2.12-2.12ZM6.294 9.994a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z"
      fill="#4D4D4D"
    ></path>
  </svg>
</template>
